import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** The settings being saved. The handler runs putTeam's approval-diversion
 * guard, then mirrors the applied subtrees whole (Mongo-save parity). */
export const saveManagedReturnsSettings = unaryRpc({
  name: "saveManagedReturnsSettings" as const,
  input: z.object({
    teamId: z.string(),
    settings: z.object({
      redoManagedReturns: z.any().optional(),
      reFulfillment: z.any().optional(),
    }),
    protectedSettingsAction: z
      .enum(["bypassApproval", "requestApproval"])
      .optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
});
